import styled from '@emotion/styled'
import { Avatar, Button, Chip, Dialog, Divider, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, Tooltip } from '@mui/material';
import { Box } from '@mui/system'
import React, { useContext, useEffect, useState } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
const Wrapper=styled('span')(({theme})=>({
    padding: '10px 15px',
    background:theme.palette.background.default,
     width: '100%',
    border: `1px solid ${theme.palette.third.main}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    borderRadius: '3px',

}))

const StyledTypography=styled(Box)(({theme})=>({
    fontWeight: '600',
    fontSize: '16px',
}))
const StyledTypographyDetail=styled(Box)(({theme})=>({
    fontWeight: '400',
    fontSize: '16px',
    marginLeft:"20px"
}))
const Detail=styled(Box)(({theme})=>({
    display:'flex',
    flexDirection:'column'
}))


// const members=[
//   {
//     name:"Solomon Tesfa",
//     pic:'/images/photo.png',
//     email:'solomon@gmail.com',
//     role:'Co PI'
//   },
//    {
//     name:"Tsion Tesfa",
//     pic:'/images/photo.png',
//     email:'solomon@gmail.com',
//     role:'PI',
//   },
//    {
//     name:"Leul Tesfa",
//     pic:'/images/photo.png',
//     email:'solomon@gmail.com',
//     role:'Member'
//   },
// ]

export default function FuntionLoggerDetail(props) {
  const api=useAxiosPrivate()
  const {rowData,summary,rowMeta}=props
  const [detail,setDetail]=useState("")
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`log/functionDetail/${rowData[0]}`,{
            signal:controller.signal
          })
          isMounted &&  setDetail(response.data)}
        catch(err){
          console.error(err)
        }
      }
      getData();
            return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[])

  return (
    <>
    <tr>
    <td colSpan="20">
      <Wrapper>
      <Detail>
        <StyledTypography>
         Log Detail:
        </StyledTypography>
        <StyledTypographyDetail>
        {detail}
        </StyledTypographyDetail>

      </Detail>
      </Wrapper>
        </td></tr>
    </>
  )
}
